import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MergeTransferComponent} from './merge-transfer/merge-transfer.component';
import {SharedModule} from "../../shared/shared.module";
import {JvUiModule} from "../../../../projects/jv-ui/src/lib/jv-ui.module";
import {JvCommonModule} from "../../../../projects/jv-common/src/lib/jv-common.module";
import {AccountingModule} from "../../../../projects/accounting/src/lib/accounting.module";


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        JvUiModule,
        JvCommonModule,
        AccountingModule
    ],
    declarations: [MergeTransferComponent]
})
export class UtilitiesModule {
}
